import {
	MDBBtn,
	MDBCol,
	MDBContainer,
	MDBRow,
	MDBBox,
	MDBAnimation,
} from "mdbreact";
import * as React from "react";

import PropTypes from "prop-types";

import AnimatedHeaderBegin from "../components/Headers/AnimatedHeaderBegin/AnimatedHeaderBegin";
import SEO from "../components/SEO/Seo";
import { Link } from "gatsby";
import Layout from "../Layouts/MasterLayout/MasterLayout";

// Assets header
import BackgroundImage from "../assets/images/home/headerBackground.png";
import LetteringImage from "../assets/images/home/lettering.png";
//import ModalidadesImage from "../assets/images/home/modalidades.png";
import CarouselCampanha2022 from "../components/CarouselCampanha2022/CarouselCampanha2022";
import imgPc from "../assets/images/home/curvas_nivel.png";
import EntradaSite from "../components/EntradaSite/EntradaSite";
import VideoDestaque from "../components/VideoDestaque/VideoDestaque";

import HeaderBalloonSmall from "../assets/images/home/lettering.png";
import HeaderBackgroundSmall from "../assets/images/home/headerBackgroundMobile.png";

import CarouselCursos from "../components/CarouselCursos/CarouselCursos";

import CardPhotoText from "../components/CardPhotoText/cardPhotoText";
import CardDepo from "../components/CardDepo/cardDepo";

import BannerResponsivo from "../components/BannerResponsivo/BannerResponsivo";

import Filter from "../components/FiltroCurso/FiltroCurso";

import BlackWeek from "../components/PopUp/blackweek";

import "../components/Css/index.css";

// Imagens de topo
let LetteringImageProp = (
	<img
		src={LetteringImage}
		alt="Vestibular Feevale"
		className="img-fluid d-flex ml-5 ml-md-0"
		style={{ width: "100%" }}
	/>
);

let HeaderBallonPropSmall = (
	<img
		src={HeaderBalloonSmall}
		alt="Conheça as vantagens para ingressar na Universidade Feevale. Bolsas e descontos."
		className="img-fluid"
	/>
);

// let ModalidadesImageProp = (
// 	<img
// 		src={ModalidadesImage}
// 		alt="Escolha sua modaldade: Presencial, Híbrido ou Digital-EAD"
// 		className="img-fluid"
// 	/>
// );

export default function Index({ pageContext: { cursos, listaGrupoCursos } }) {
	Index.propTypes = {
		pageContext: PropTypes.object.isRequired,
		cursos: PropTypes.array,
		listaGrupoCursos: PropTypes.object,
	};

	return (
		<Layout>
			<SEO
				title="Graduação"
				description="Conheça a graduação da Universidade Feevale. Ingresse via vestibular, transferências e reingresso. Inscrições abertas."
			/>
			{/**/}
			<EntradaSite 
			nomePessoa="Diego Becker"
  			cursoPessoa="Graduado em Arquitetura"
			logoCentralSrc="https://www.feevale.br/s/conteudo/7d00440e-8d16-4ce3-b02e-bef4aadeeee5/Lettering_Vestibular_2027_reduzido_1.png" />

		{/*	<AnimatedHeaderBegin
				//contentA={LetteringImageProp}
				//contentB={HeaderBallonPropSmall}
				// contentB={ModalidadesImageProp}
				image={BackgroundImage}
				imageb={HeaderBackgroundSmall}
				href="/cursos/medicina"
			/> */}

			<div className="text-center text-md-left">
				<MDBBox className="pb-3">
					<MDBContainer>
						<MDBRow className="py-4 pb-4" style={{ color: "#000" }}>
							<MDBCol>
								<CarouselCursos cursos={listaGrupoCursos} instituto="" />
							</MDBCol>
						</MDBRow>
					</MDBContainer>
				</MDBBox>
				<MDBBox style={{ backgroundColor: "#fff" }} className="pb-md-5 pt-md-4">
					<MDBContainer>
						<MDBRow className="py-4">
							<MDBCol style={{ color: "#000" }} md="4" className="mb-2">
								<CardPhotoText
									CorBotao="roxo"
									Nome="Graduação Presencial"
									Texto="Uma experiência completa e imersiva na Feevale! São cursos dinâmicos e atuais, que contam com todo o suporte da 
									infraestrutura presencial. Prepare-se para viver o aprendizado de forma intensa e prática, com a excelência 
									acadêmica que você merece."
									LinkImage="https://www.feevale.br/s/conteudo/59794457-494e-40bc-943e-51f6048f7e37/presencial_1.png"
									NomeFoto="Igor Oliveira"
  									CursoFoto="Graduado em Enfermagem"
								/>
							</MDBCol>
							<MDBCol style={{ color: "#000" }} md="4" className="mb-2">
								<CardPhotoText
									Nome="Graduação Semipresencial"
									Texto="A flexibilidade que você precisa, com a qualidade Feevale! O curso compõe um percurso formativo que combina disciplinas 
									presenciais, a distância e aquelas que reúnem atividades nos dois modelos. O formato semipresencial permite que você 
									organize sua rotina de estudos com autonomia, sem abrir mão da interação direta com professores e colegas."
									LinkImage="https://www.feevale.br/s/conteudo/0ae8ec9c-72d8-497b-8174-8145a70532fb/semipresencial.png"
									NomeFoto="Victória Vendramini"
  									CursoFoto="Graduada em Biomedicina"
								/>
							</MDBCol>
							<MDBCol style={{ color: "#000" }} md="4" className="mb-2">
								<CardPhotoText
									CorBotao="laranja"
									Nome="Graduação EAD"
									Texto="Feevale EAD: a qualidade Feevale, onde você estiver! Cursos pensados para oferecer a melhor experiência de aprendizagem, 
									com aulas síncronas e suporte contínuo de professores especializados. Com a flexibilidade do ensino a distância, você pode seguir 
									seu caminho acadêmico de qualquer lugar do mundo."
									LinkImage="https://www.feevale.br/s/conteudo/4711b427-2cfe-4863-81d4-99fab6338732/semi_1.png"
									NomeFoto="Keila Soeiro"
  									CursoFoto="Graduada em Análise e Desenvolvimento de Sistemas"
								/>
							</MDBCol>
						</MDBRow>
					</MDBContainer>
				</MDBBox>
				<MDBBox style={{ backgroundColor: "#fff" }} className="pb-5 pt-4">
					<MDBContainer>
						<MDBRow className="py-4">
							<MDBCol style={{ color: "#000" }} md="8">
								<h1 className="text-primary py-2 text-center text-md-left saira-title">
									Ficou na dúvida?
								</h1>
								<p className="text-primarytext-md-left">
									Se você ainda estiver com dúvidas sobre qual modalidade
									escolher ou quer conversar com alguém sobre qualquer outra
									questão, clique no botão ao lado para conversar com a gente.
								</p>
							</MDBCol>

							<MDBCol
								style={{ color: "#000" }}
								md="4"
								className="d-flex flex-column justify-content-around"
							>
								<a to="/inscrevase">
									<MDBBtn
										size="lg"
										block
										color="secondary"
										className="text-white font-weight-bold bg-white border-secondary border"
										target="_blank"
										rel="noreferrer"
										href="https://wa.me/555135868800"
									>
										Chama no Whats!
									</MDBBtn>
								</a>
							</MDBCol>
						</MDBRow>
					</MDBContainer>
				</MDBBox>
			</div>
			<VideoDestaque
				titulo="REFERÊNCIAS IMPULSIONAM REFERÊNCIAS"
				videoUrl="https://www.youtube.com/embed/IeQQmLLFOV8?si=TtsjdhFkdEvBZEBi"
				videoTitle="Venha viver experiências transformadoras aqui na Universidade Feevale."
				backgroundImage="https://www.feevale.br/s/conteudo/e1d72fbd-f939-448e-9592-3b5dfc945d0e/fundovideo.png"
			/>
			{/* ----------------------------------------------------------------------- */}
			<div style={{ backgroundColor: "#5ba82d" }}>
				<MDBContainer className="pt-5">
					<MDBRow className="pb-4 text-center">
						<MDBCol>
							<Link to="/inscrevase">
								<MDBBtn
									className="px-5"
									color="secondary"
									style={{color: "#ffffff"}}
								>
									<span className="h6 font-weight-bold">
										COMECE A ESTUDAR NA UNIVERSIDADE FEEVALE
									</span>
								</MDBBtn>
							</Link>
						</MDBCol>
					</MDBRow>
				</MDBContainer>
			</div>
			{/* ----------------------------------------------------------------------- */}
			<MDBBox style={{ backgroundColor: "#5ba82d" }}>
				<MDBContainer className="text-white pt-5">
					<MDBRow className="pb-5">
						<MDBCol md={12} className="text-center pb-4">
							<h3 className="font-weight-bold saira-title" style={{color:"#c9f04b"}}>
								O que dizem os alunos que se tornaram referência
							</h3>
						</MDBCol>
						<MDBCol md={4} className="">
							<CardDepo
								Nome="Felipe Machado"
								SubNome="Bacharel em Design"
								Texto="Eu sabia que dentro de mim havia algo que eu precisava colocar para fora. 
								O que eu mais queria era poder expressar tudo o que morava dentro da minha cabeça. Encontrei na arte 
								uma maneira de colorir os meus dias."
								LinkImageDepo="https://www.feevale.br/s/conteudo/71479be3-51f9-4036-8b5e-a78158315e60/_MG_1761.jpg"
							/>
						</MDBCol>
						<MDBCol md={4} className="">
							<CardDepo
								Nome="Aline Seibel"
								SubNome="Bacharela em Moda"
								Texto="Liderar uma equipe parecia uma realidade muito distante. Com pessoas que passaram 
								pelo meu caminho, o medo do novo logo foi embora. Ter ao meu lado pessoas que crescem comigo e 
								enfrentam desafios diários é transformador."
								LinkImageDepo="https://www.feevale.br/s/conteudo/8cd2f792-2863-418f-9aa6-581138204907/_MG_3820_V2_1.jpg"
							/>
						</MDBCol>
						<MDBCol md={4} className="">
							<CardDepo
								Nome="Maicon Backes"
								SubNome="Bacharel em Sistemas de Informação"
								Texto="Me inserir no mercado de trabalho não foi difícil. Eu tive o direcionamento certo. 
								E encontrei reconhecimento na minha área, algo que eu nunca imaginava que conseguiria. 
								Tenho estabilidade e o retorno que tenho é recompensador."
								LinkImageDepo="https://www.feevale.br/s/conteudo/4085c0a1-f366-4f0d-b1b4-b38fab06cbb6/_MG_1816.jpg"
							/>
						</MDBCol>
					</MDBRow>
				</MDBContainer>
			</MDBBox>
			<MDBBox bgColor="white">
				<MDBContainer className="text-white pt-5">
					<MDBRow className="pb-5">
						<MDBCol md={12} className="pr-md-5 mr-md-5">
							<MDBRow className="pb-4">
								<MDBCol className="text-center">
									<h3 className="font-weight-bold text-white bg-primary pb-2 pt-2 saira-title">
										BOLSAS E FINANCIAMENTOS
									</h3>
								</MDBCol>
							</MDBRow>
							<MDBRow className="imagensindex">
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://www.feevale.br/institucional/atendimento-financeiro-e-financiamento-estudantil/opcoes-de-financiamento"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/cdcc3fb4-63ef-400f-8987-252ddc8a639c/Banner-Banrisul.jpg"
											alt="Crédito universitário Banrisul. A gente descomplica pra você"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
								{/* <MDBCol col={6} xs={6} md={6} className="pb-2">
									<Link to={"/descontos"}>
										<img
											src="https://via.placeholder.com/487x228/FFFFFF/000000?text=BANNER%20DESCONTOS%20(487x228)"
											alt="Bolsas de até 50%* e 30%*! Clique e acesse"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</Link>
								</MDBCol> */}
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://www.pravaler.com.br/campanhas/lp-campeao/?ies_code=131&nome=FEEVALE&faculdade"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/2fdcb54e-5c7d-499a-afc9-bdb834ebffcd/MicrosoftTeams-image_(27).png"
											alt="Financiamento estudantil SEM JUROS é com Pravaler."
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://sicredipioneira.com.br/fale-conosco"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/fd7723a3-9906-4d39-86e0-285e8ccb5886/Banner-Sicredi.jpg"
											alt="Crédito universitário Sicredi"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://www.feevale.br/institucional/atendimento-financeiro-e-financiamento-estudantil/opcoes-de-financiamento/credies-feevale"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/4566498c-a049-4b68-91ff-7217b59473e7/Banner-Credies.png"
											alt="CredIES Feevale sua graduação é agora! acesse credies.org"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
							</MDBRow>
							<MDBRow className="py-4">
								<MDBCol style={{ color: "#000" }} md="8">
									<h1 className="text-primary py-2 text-center text-md-left saira-title">
										Ficou na dúvida?
									</h1>
									<p className="text-primarytext-md-left">
										Na Universidade Feevale, as possibilidades de ingresso são
										muitas! Converse com a gente e tire suas dúvidas
									</p>
								</MDBCol>

								<MDBCol
									style={{ color: "#000" }}
									md="4"
									className="d-flex flex-column justify-content-around"
								>
									<a to="/inscrevase">
										<MDBBtn
											size="lg"
											block
											color="secondary"
											className="text-white font-weight-bold bg-white border-secondary border"
											target="_blank"
											rel="noreferrer"
											href="https://wa.me/555135868800"
										>
											Chama no Whats!
										</MDBBtn>
									</a>
								</MDBCol>
							</MDBRow>
						</MDBCol>
					</MDBRow>
				</MDBContainer>
			</MDBBox>

			{/* ----------------------------------------------------------------------- */}
			<div className="nowhite-color">
				<MDBContainer className="pt-5">
					<MDBRow>
						<MDBCol>
							<h3 className="text-primary font-weight-bold saira-title">
								ENTENDA O FINANCIAMENTO ESTUDANTIL
							</h3>
						</MDBCol>
					</MDBRow>

					<MDBRow className="pb-3">
						<MDBCol>
							{/*
						<p className="text-black">
							Escolher uma graduação não é uma tarefa fácil e a gente sabe
							disso. Pra ajudar, criamos uma série de conteúdos bem bacanas pra
							entender e escolher o curso que mais combina com você.
						</p>*/}
						</MDBCol>
					</MDBRow>

					<MDBRow className="text-center imagensindex">
						{/* 
					<MDBCol xs="12" sm="12" md="3" className="pb-2">
						<a
							href="https://conteudo.feevale.br/qual-a-diferenca-entre-bacharelado-licenciatura-e-tecnologo"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src="https://www.feevale.br/s/conteudo/2dd612d1-a49e-45dd-8812-4baca2f816cd/04_Institucional24_IdentidadeVisual_BacharelLicenTenol_487x228px.png"
								alt=""
								className="img-fluid col-12 p-0 rounded-lg"
							/>
						</a>
					</MDBCol>
					*/}
						<MDBCol xs="12" sm="12" md="3" className="pb-2">
							<a
								href="https://conteudo.feevale.br/financiamento-estudantil"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src="https://www.feevale.br/s/conteudo/f6db6951-87a4-4e5c-961b-bd06b68526d8/04_Institucional24_IdentidadeVisual_Finaciamento_487x228px.png"
									alt=""
									className="img-fluid col-12 p-0 rounded-lg"
								/>
							</a>
						</MDBCol>
						{/* 
					<MDBCol xs="12" sm="12" md="3" className="pb-2">
						<a
							href="https://graduacao.feevale.br/quiz/"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src="https://www.feevale.br/s/conteudo/dfb51e41-6fff-45ab-8c8c-12c8605dfe0e/04_Institucional24_IdentidadeVisual_OqueCursar_487x228px.png"
								alt=""
								className="img-fluid col-12 p-0 rounded-lg"
							/>
						</a>
					</MDBCol>
					*/}
					</MDBRow>
				</MDBContainer>
			</div>
		</Layout>
	);
}
